export const initialState = {
  documentTypeId: null,
  changedAllowedStatesPermissions: {},
  deletedAllowedStates: [],
  documentTypeWithAllowedStates: { allowedStates: [] },
  userGroups: [],
  pager: { page: 0, pageSize: 10 },
  allowSave: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitDocumentTypeWithAllowedStates':
      return onInitDocumentTypeWithAllowedStates(state, action);
    case 'OnInitUserGroups':
      return onInitUserGroups(state, action);
    case 'OnChangeAllowedStatesPermission':
      return onChangeAllowedStatesPermission(state, action);
    case 'OnSaving':
      return onSaving(state, action);
    case 'OnSaveFailed':
      return onSaveFailed(state, action);
    case 'OnPageChange':
      return onPageChange(state, action);
    case 'OnRowsPerPageChange':
      return onRowsPerPageChange(state, action);
    case 'OnRemoveAllowedState':
      return onRemoveAllowedState(state, action);
    case 'OnFilterList':
      return onFilterList(state, action);

    default:
      return state;
  }
}

function onFilterList(state, action) {
  return {
    ...state,
    documentTypeWithAllowedStates: action.documentTypeWithAllowedStates,
    userGroups: action.userGroups,
    pager: {
      ...state.pager,
      page: 0
    }
  };
}

function onInitDocumentTypeWithAllowedStates(state, action) {
  const { documentTypeWithAllowedStates } = action;
  return {
    ...state,
    documentTypeId: documentTypeWithAllowedStates.id,
    documentTypeWithAllowedStates: documentTypeWithAllowedStates,
    changedAllowedStatesPermissions: {},
    deletedAllowedStates: [],
    allowSave: false
  };
}

function onInitUserGroups(state, action) {
  const { userGroups } = action;
  return {
    ...state,
    userGroups: userGroups
  };
}

function onChangeAllowedStatesPermission(state, action) {
  const { allowedStateId, userGroupId, value } = action;
  const changedState = !state.changedAllowedStatesPermissions[allowedStateId] ? {} : state.changedAllowedStatesPermissions[allowedStateId];
  return {
    ...state,
    allowSave: true,
    changedAllowedStatesPermissions: {
      ...state.changedAllowedStatesPermissions,
      [allowedStateId]: { ...changedState, [userGroupId]: value }
    }
  };
}

function onSaving(state) {
  return {
    ...state,
    allowSave: false
  };
}

function onSaveFailed(state) {
  return {
    ...state,
    allowSave: true
  };
}

function onPageChange(state, action) {
  const { page } = action;
  return {
    ...state,
    pager: {
      ...state.pager,
      page: page
    }
  };
}

function onRowsPerPageChange(state, action) {
  const { pageSize } = action;
  return {
    ...state,
    pager: {
      ...state.pager,
      pageSize: pageSize,
      page: 0
    }
  };
}

function onRemoveAllowedState(state, action) {
  const { allowedStateId } = action;
  const filtered = state.documentTypeWithAllowedStates.allowedStates.filter(x => x.id !== allowedStateId);
  const pager =
    state.pager.page > 0 && filtered.length <= (state.pager.page - 1) * state.pager.pageSize
      ? { ...state.pager, page: --state.pager.page }
      : state.pager;
  return {
    ...state,
    pager: pager,
    allowSave: true,
    deletedAllowedStates: [...state.deletedAllowedStates, allowedStateId],
    documentTypeWithAllowedStates: {
      ...state.documentTypeWithAllowedStates,
      allowedStates: [...filtered]
    }
  };
}
